"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creditCardNumberCursorHelper = creditCardNumberCursorHelper;
function creditCardNumberCursorHelper() {
  var diff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var newDiff = diff;
  var nextCharIsSpace = value.substr(index, 1) === ' ';
  if (diff === 1 && nextCharIsSpace) {
    newDiff = 2;
  }
  if (diff === 2 && !nextCharIsSpace) {
    newDiff = 1;
  }
  return newDiff;
}